// removed by extract-text-webpack-plugin
module.exports = {"amplitude":"_3sNsAAwO6vJzARd7x1Wxh_","amplitude__canvas":"oQbrjRy2jLnwlK9vBRwYr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Wave/Wave.css
// module id = 335
// module chunks = 0